import React from 'react';
import styled from 'styled-components/macro';
import { useFormik } from 'formik';
import { Link, useLocation } from 'react-router-dom';
import { Button, TextField as MuiTextField } from '@mui/material';
import { spacing } from '@mui/system';

import useAuth from '../../hooks/useAuth';
import { PasswordInput } from '../PasswordInput';
import { inviteRegisterRules } from './rules';
import { PATH_AUTH } from '../../constants';

const TextField = styled(MuiTextField)<{ my?: number }>(spacing);

const DEFAULT_VALUES = {
  firstName: '',
  lastName: '',
  password: '',
  confirmPassword: '',
  submit: false
};

type SignUpValues = {
  firstName: string;
  lastName: string;
  password: string;
  confirmPassword: string;
  submit: boolean;
};

const InviteRegister: React.FC = () => {
  const { inviteRegister } = useAuth();
  const { search } = useLocation();
  const code = new URLSearchParams(search).get('code');

  const { errors, handleBlur, handleChange, handleSubmit, touched, values } =
    useFormik<SignUpValues>({
      initialValues: DEFAULT_VALUES,
      validationSchema: inviteRegisterRules,
      onSubmit: async (values) => {
        inviteRegister(
          values.firstName,
          values.lastName,
          values.password,
          values.confirmPassword,
          code
        );
      }
    });

  return (
    <form noValidate onSubmit={handleSubmit}>
      <TextField
        type="firstName"
        name="firstName"
        label="First name"
        value={values.firstName}
        error={Boolean(touched.firstName && errors.firstName)}
        fullWidth
        helperText={touched.firstName && errors.firstName}
        onBlur={handleBlur}
        onChange={handleChange}
        my={3}
      />
      <TextField
        type="lastName"
        name="lastName"
        label="Last name"
        value={values.lastName}
        error={Boolean(touched.lastName && errors.lastName)}
        fullWidth
        helperText={touched.lastName && errors.lastName}
        onBlur={handleBlur}
        onChange={handleChange}
        my={3}
      />
      <PasswordInput
        value={values.password}
        name="password"
        label="Password"
        onChange={handleChange}
        onBlur={handleBlur}
        error={Boolean(touched.password && errors.password)}
        helperText={touched.password && errors.password}
        my={3}
      />
      <PasswordInput
        value={values.confirmPassword}
        name="confirmPassword"
        label="Confirm password"
        onChange={handleChange}
        onBlur={handleBlur}
        error={Boolean(touched.confirmPassword && errors.confirmPassword)}
        helperText={touched.confirmPassword && errors.confirmPassword}
        my={3}
      />
      <Button type="submit" fullWidth variant="contained" color="primary">
        Create Account
      </Button>
      <Button component={Link} to={PATH_AUTH.SIGN_IN} fullWidth color="primary">
        Log in
      </Button>
    </form>
  );
};

export default InviteRegister;
